import { render, staticRenderFns } from "./EmployeeNotes.vue?vue&type=template&id=76c660bb&scoped=true&"
import script from "./EmployeeNotes.vue?vue&type=script&lang=js&"
export * from "./EmployeeNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c660bb",
  null
  
)

export default component.exports